import React from 'react'
import { themeGet } from '@styled-system/theme-get'
import { useContentful } from '@pcln/contentful-components'
import styled from 'styled-components'
import HomeContent from './HomeContent'
import useContent from '../CustomHooks/useContent'
import SearchForm from '../SearchForm'
import Hero from '../Heros/Hero'
import FreedomImage from '../../assets/images/hero/pcln-hp-hero-freedom.jpg'

const StyledHero = styled(Hero)`
  img {
    height: 100%;
    object-fit: cover;
    ${themeGet('mediaQueries.xxl')} {
      height: auto;
      width: 100%;
    }
  }
`
export default function HomeDesktop() {
  const heroImageResponse: any = useContentful('heroImage')
  const heroImage = useContent(heroImageResponse)
  const heroProps = {
    img: `${FreedomImage}?opto&auto=webp&crop=2000,800,x200,x400,safe`,
    description: 'Freedom Sale',
    contentfulImage: heroImage
  }

  return (
    <>
      <StyledHero {...heroProps}>
        <SearchForm />
      </StyledHero>
      <HomeContent />
    </>
  )
}
